///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IUser = Meevo.Plugins.Reports.IUser;


    export class UsersCollection extends SmartMoverApiCollection<IUser> implements IApiCollection<IUser> {

        protected get smartMoverHiddenValue(): SmartMoverHiddenValue {
            return SmartMoverHiddenValue.EmptyArray;
        }

        protected get url() {
            return 'report/User';
        }

        constructor(connectedModel: ModelValueType[], items: IUser[] = [], options: ICollectionOptions<IUser> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                'showEmployeesOnly': null,
                'includeActive': true,
                'includeInactive': false,
                'includeDeleted': false,
                'showTerminated': false,
                'firstName': '',
                'lastName': '',
                'coFilterByLocationId': null,
                'coBusinessTypeId': null,
                'filter': ''
            });
        }
    }

}
